<div class="card">
    <form  [formGroup]="docOtherInfoForm" (ngSubmit)="saveDocOtherInfo();">
        <div class="card-body">
            <div class="container-fluid">
                <div class="form-group">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label class="form-label">Services: </label>
                            <ckeditor [editor]="Editor"  formControlName="services"></ckeditor>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <label class="form-label">Experience: </label>
                            <ckeditor [editor]="Editor"  formControlName="experience"></ckeditor>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <label class="form-label">Specializations: </label>
                            <ckeditor [editor]="Editor"  formControlName="specializations"></ckeditor>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="form-group">
                            <label class="form-label">Awards & Recognitions: </label>
                            <ckeditor [editor]="Editor"  formControlName="awards_recognitions"></ckeditor>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <label class="form-label">Registration: </label>
                            <ckeditor [editor]="Editor"  formControlName="registration"></ckeditor>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <label class="form-label">Education Details: </label>
                            <ckeditor [editor]="Editor"  formControlName="education_details"></ckeditor>
                        </div>
                    </div>


                    <div class="col-md-12">
                        <div class="form-group">
                            <label class="form-label">Meta Title: </label>
                            <input type="text" class="form-control"  formControlName="meta_title">
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <label class="form-label">Meta Description: </label>
                            <textarea class="form-control" formControlName="meta_description"></textarea>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <label class="form-label">OG Title: </label>
                            <input type="text" class="form-control"  formControlName="og_title">
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <label class="form-label">OG Description: </label>
                            <textarea class="form-control" formControlName="og_description"></textarea>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="card-footer">
            <button type="submit" [disabled]="loading" class="btn btn-primary"><i *ngIf="loading" class="fa fa-spin fa-spinner"></i>
                 Submit
                <!-- <span>Create Doctor</span> -->
            </button>
        </div>
    </form>

</div>